import useLang from "../../../hooks/useLang";
import { useParams } from "react-router-dom";
import { useHasAccessFunctions } from "../../../hooks/useHasAccess";
import useOrganisationId from "../../organisations/hooks/useOrganisationId";

const useReportPage = () => {
  const lang = useLang();
  const organisationId = useOrganisationId();
  const { reportId } = useParams();
  const { hasAccessToLink } = useHasAccessFunctions();

  const page = {
    hasAccess: hasAccessToLink(`/${organisationId}/reports`),
    header: {
      title: `${lang("reports.report")} ${reportId}`,
    },
  };

  return page;
};

export default useReportPage;
